import { inject, Injectable, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { interval } from 'rxjs';
import { BranchService } from '../../../service/branch.service';
import { LocationCamera } from '../../../types';

@Injectable()
export class InstallerCameraService {
  private branchService = inject(BranchService);

  private branchId = signal<number | undefined>(undefined);

  private _cameras = signal<LocationCamera[]>([]);
  public cameras = this._cameras.asReadonly();

  constructor() {
    interval(60 * 1000)
      .pipe(takeUntilDestroyed())
      .subscribe(() => {
        this.refreshBranchCameras();
      });
  }

  public setBranchId(id: number) {
    this.branchId.set(id);
    this.refreshBranchCameras();
  }

  private refreshBranchCameras() {
    if (!this.branchId()) return;

    this.branchService.getBranchAvailableCameras(this.branchId()).subscribe((cameras) => {
      this._cameras.set(cameras.items);
    });
  }
}
